import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, MenuItem,
} from '@mui/material';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../styles/MyStyles";
import {GetCookieInfo} from "../../logic/CookieManager";
import * as DataProvider from "../../logic/DataProvider";
import {GetEnumValues} from "../../logic/EnumHelper";

const NewTicketPage = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [newTicket, setNewTicket] = useState({
        type: '',
        title: '',
        firstMessage: ''
    });

    useEffect(() => {
    }, []);

    const validateForm = () => {
        let newErrors = {};

        if (newTicket.type === '') {
            newErrors.type = 'Type is required.';
        }

        if (!newTicket.title.trim()) {
            newErrors.title = 'Title is required.';
        }

        if (!newTicket.firstMessage.trim()) {
            newErrors.firstMessage = 'Message is required.';
        }

        return newErrors;
    };

    const handleFieldChange = (event) => {
        setNewTicket({
            ...newTicket,
            [event.target.name]: event.target.value,
        });
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKETING_URL}/ticket`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(newTicket)
                }
            );
            if (response.ok) {
                const data = await response.json();

                let bundle = DataProvider.GetClientBundle();
                if (bundle.tickets) {
                    bundle.tickets.push(data.data);
                } else {
                    bundle.tickets = [data.data];
                }
                handleGoBack();
            } else {
                console.log('Ticket creating failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const getTicketTypeMenuItems = () => {
        let enumElems = GetEnumValues('ticketType');
        if (enumElems) {
            let items = [];
            for (const [key, value] of Object.entries(enumElems)) {
                let intKey = parseInt(key);

                if (intKey === 9) {
                    continue;
                }

                items.push(
                    <MenuItem key={intKey} value={intKey}>
                        {value}
                    </MenuItem>
                );
            }
            return items;
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                New Ticket
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Cancel
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSendRequest}>
                    Create ticket
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={newTicket.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {getTicketTypeMenuItems()}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Title</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="title"
                                label="Title"
                                value={newTicket.title}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.title}
                                helperText={errors.title}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Message</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="firstMessage"
                                label="Message"
                                value={newTicket.firstMessage}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                multiline
                                rows={3}
                                error={!!errors.firstMessage}
                                helperText={errors.firstMessage}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default NewTicketPage;
